import { useState } from 'react';
import { Star } from 'lucide-react';
import { LeaveReviewDialog } from '@/components/social/LeaveReviewDialog';

interface InlineRatingCardProps {
	transactionId: string;
	reviewedUserId: string;
	reviewedUserName: string;
	onDismiss: () => void;
}

/**
 * Surfaces a "How was your trade with @user?" prompt at the bottom of the
 * thread once an associated transaction has been completed. Reuses the
 * existing LeaveReviewDialog.
 */
export const InlineRatingCard = ({
	transactionId,
	reviewedUserId,
	reviewedUserName,
	onDismiss,
}: InlineRatingCardProps) => {
	const [open, setOpen] = useState(false);
	return (
		<>
			<div className="rounded-xl border border-[hsl(var(--active-gold)/0.25)] bg-[hsl(var(--active-gold)/0.06)] px-3.5 py-3 flex items-center gap-3">
				<div className="h-9 w-9 rounded-full bg-[hsl(var(--active-gold)/0.15)] grid place-items-center text-[hsl(var(--active-gold))] shrink-0">
					<Star className="h-4 w-4" />
				</div>
				<div className="flex-1 min-w-0">
					<div className="text-[13px] font-medium text-foreground leading-tight">
						How was your trade with {reviewedUserName}?
					</div>
					<div className="text-[11.5px] text-muted-foreground leading-tight mt-0.5">
						Your rating helps other collectors trust each other.
					</div>
				</div>
				<button
					type="button"
					onClick={() => setOpen(true)}
					className="h-8 px-3 rounded-full text-[12px] font-medium bg-[hsl(var(--active-gold))] text-black hover:opacity-90 shrink-0"
				>
					Rate
				</button>
				<button
					type="button"
					onClick={onDismiss}
					className="text-[11.5px] text-muted-foreground hover:text-foreground shrink-0"
				>
					Later
				</button>
			</div>
			<LeaveReviewDialog
				open={open}
				onOpenChange={(v) => {
					setOpen(v);
					if (!v) onDismiss();
				}}
				transactionId={transactionId}
				reviewedUserId={reviewedUserId}
				reviewedUserName={reviewedUserName}
			/>
		</>
	);
};

export default InlineRatingCard;
